const offerSubscriptionStatuses = {
  IDLE: "IDLE",
  SUBMITTING: "SUBMITTING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
};

export default offerSubscriptionStatuses;
